export default __webpack_public_path__ + "static/media/Insight_data_tableau_récap_13.1e4602ab.svg";